import i18n from 'i18next';
import { normalizeLanguage } from '../../utils/languagePreference';
import config from '../../../config';
import { showsProjectStoreyPlan, showsProjectUnitsTab } from '../../utils/vietnam';
import { salesChartBlocked } from '../../utils/preSalesLaunch';
import { chartLanguage } from '../../utils/chartLanguage';

export const editRoutes = (id, lawyerIsEnabled, panelBankersIsEnabled, serviceCompanyID) => {
  const links = [
    { text: 'Edit', value: `/projects/${id}/edit/` },
    { text: 'Unit Layouts', value: `/projects/${id}/layouts/` },
    { text: 'Pricing Package', value: config.get('developerURL') && serviceCompanyID ? `${config.get('developerURL')}/c/${serviceCompanyID}/projects/${id}/edit?tab=package_pricings` : `/projects/${id}/package_pricings/` },
    { text: 'Documents', value: `/projects/${id}/documents/` },
    { text: 'Logo', value: `/projects/${id}/logo/` },
    { text: 'Pictures', value: `/projects/${id}/pictures/` },
    { text: 'Videos', value: `/projects/${id}/videos/` },
  ];
  if (lawyerIsEnabled) {
    links.push({ text: 'Panel Lawyers', value: `/projects/${id}/lawyers/` });
  }
  if (panelBankersIsEnabled) {
    links.push({ text: 'Panel Bankers', value: `/projects/${id}/bankers/` });
  }
  return links;
};

// `auth` is the last argument and defaults to null so an unmigrated caller keeps the full menu:
// both Vietnam gates below read it, and both answer "show" when it is absent.
export const routes = (id, data, showReport = false, isSiteplan = false, auth = null) => {
  const {
    siteplan, salesChartEnabled, siteplanAppEnabled, isLaunchMode, salesChartRefreshSeconds,
  } = data || {};
  const hasSiteplan = siteplan && siteplan.id && siteplan.key;
  const links = [
    { text: 'Overview', value: `/projects/${id}/` },
  ];
  if (showsProjectUnitsTab(auth)) { // CPI-1272
    links.push({ text: 'Units', value: `/projects/${id}/units/` });
  }
  // CPI-1274; Pre-Sales Launch: no link for a role HQ has blocked from the sales chart
  if (salesChartEnabled && showsProjectStoreyPlan(auth, data) && !salesChartBlocked(auth, data)) {
    // CPI-1284: the chart opens in the Showroom's current language. The header switcher
    // (components/LanguageSwitcher.jsx) saves the pick to the profile and moves i18next at once,
    // but leaves the redux profile (auth.language) as it was at login, so the live i18next value
    // is read first and auth.language is only the fallback. Launch mode keeps its auto-refresh
    // in front.
    const storeyPlanQuery = [`language=${chartLanguage(normalizeLanguage(i18n.language) || normalizeLanguage(auth && auth.language) || 'en')}`];
    if (isLaunchMode) storeyPlanQuery.unshift(`refresh=${salesChartRefreshSeconds}`);
    links.push({ text: 'Storey Plan', value: `${config.get('bookApiURL')}/reports/storey_plan/${id}/?${storeyPlanQuery.join('&')}` });
  }
  if (siteplanAppEnabled && hasSiteplan) {
    links.push({ text: 'Site Plan', value: `${config.get('salesChartURL')}/?projectID=${id}&lang=${encodeURIComponent(normalizeLanguage(i18n.language) || normalizeLanguage(auth && auth.language) || 'en')}` });
  }
  if (showReport && !isSiteplan) {
    links.push({ text: 'Reports', value: `/projects/${id}/reports/` });
  }
  if (!isSiteplan) {
    links.push({ text: 'Activities', value: `/projects/${id}/activities/` });
  }
  return links;
};



// WEBPACK FOOTER //
// ./src/containers/Project/navigations.js